import { ConditionField } from './condition-field';
import { CoordinatorService } from './coordinator.service';

export type CIPAR = {
    id?: string;
    itemId: string;
    templateId: string;
    ownerId: string;
    conditions: [string, any][];
};

export class ConditionItem {
    id: string;
    itemId: string;
    templateId: string;
    ownerId: string;
    private _conditionsMap = new Map<string, any>();

    constructor(
        public coords: CoordinatorService,
        { id, itemId, templateId, ownerId, conditions }: CIPAR,
    ) {
        this.id = id || this.coords.uniqueId();
        this.itemId = itemId;
        this.templateId = templateId;

        this.coords.user$.currentId &&
            (!ownerId || ownerId === '_unlogged') &&
            (ownerId = this.coords.user$.currentId);
        this.ownerId = ownerId;

        conditions.forEach((condition) => {
            this._conditionsMap.set(condition[0], condition[1]);
        });
    }

    hasField(k: string[]) {
        const template = this.coords.condition$.getTemplate(this.templateId);
        if (!template) return false;
        const tpl = k.slice(0, 2);
        const fK = tpl.pop();
        if (tpl.length && tpl[0] !== template.title.toLowerCase()) return false;
        for (let f of template.fieldLs) {
            if (f.title.toLowerCase() === fK) return this._conditionsMap.get(f.id) || false;
        }
        return false;
    }

    getValue(f: ConditionField | string) {
        if (f instanceof ConditionField) f = f.id;
        return this._conditionsMap.get(f);
    }
    setValue(f: ConditionField, v: any) {
        this._conditionsMap.set(f.id, v);
        this.coords.condition$.storeConditionItem(this);
    }

    hasValue(f: ConditionField | string) {
        if (f instanceof ConditionField) f = f.id;
        return this._conditionsMap.get(f) || false;
    }

    save() {
        return {
            id: this.id,
            itemId: this.itemId,
            templateId: this.templateId,
            ownerId: this.ownerId,
            conditions: Array.from(this._conditionsMap.entries()),
        };
    }
}
